import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { OptimizedTenantProvider } from "./providers/OptimizedTenantProvider";
import { QueryProvider } from "./providers/QueryProvider";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <QueryProvider>
        <OptimizedTenantProvider>
          <App />
        </OptimizedTenantProvider>
      </QueryProvider>
    </BrowserRouter>
  </React.StrictMode>
);
